import { useWindowWidth } from "@react-hook/window-size";

import { clsxMerge } from "shared/lib/helpers";

import { AccountDetailsLayout as Layout } from "@/modules/pipeline/account-details/layout";
import { AccountSection } from "@/components/modules/pipeline/account-details/sections/account-section";
import { StatusSection } from "@/components/modules/pipeline/account-details/sections/status-section";
import { LeadsSection } from "@/components/modules/pipeline/account-details/sections/leads-section";
import { NotepadSection } from "@/components/modules/pipeline/account-details/sections/notepad-section";
import { AccountAboutSection } from "@/components/modules/pipeline/account-details/sections/account-about-section";
import { AccountSummarySection } from "@/components/modules/pipeline/account-details/sections/account-summary-section";
import { AccountLastTouchSection } from "@/components/modules/pipeline/account-details/sections/account-last-touch-section";
import { AccountTargetedProspectSection } from "@/components/modules/pipeline/account-details/sections/account-targeted-prospect-section";
import { BookedMeetingCalendarEventSection } from "@/components/modules/pipeline/account-details/sections/booked-meeting-calendar-event-section";
import { useLeadsSection } from "@/modules/pipeline/account-details/hooks/use-leads-section";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { checkIfAccountShouldShowCalendarEventStatus } from "@/modules/pipeline/account-details/shared/booked-meeting-calendar-event/utils";

const LG_SCREEN_BREAKPOINT = 1024;

export const AccountDetailsTabDetails = () => {
  const { contactId, filterFunc } = useLeadsSection();
  const { accountStatus } = useAccountDetailsContext();
  const windowWidth = useWindowWidth();

  const isSmallScreen = windowWidth < LG_SCREEN_BREAKPOINT;
  const shouldShowBMCE =
    checkIfAccountShouldShowCalendarEventStatus(accountStatus);

  return (
    <Layout.GridColumns columns={isSmallScreen ? 2 : 3}>
      <Layout.GridColumn className="flex flex-col gap-2 pl-2 pr-1 pt-3">
        <AccountLastTouchSection />
        <AccountSummarySection />
        {isSmallScreen && contactId && <AccountTargetedProspectSection />}
        <AccountSection />
        {isSmallScreen && <StatusSection />}
        {isSmallScreen && shouldShowBMCE && (
          <BookedMeetingCalendarEventSection />
        )}
        <AccountAboutSection />

        {isSmallScreen && (
          <LeadsSection
            filterFunc={filterFunc}
            title={contactId ? "Other leads" : "Leads"}
          />
        )}
      </Layout.GridColumn>

      {!isSmallScreen && (
        <Layout.GridColumn className="flex flex-col gap-2 px-1 pt-3">
          {contactId && <AccountTargetedProspectSection />}
          <StatusSection />
          {shouldShowBMCE && <BookedMeetingCalendarEventSection />}
          <LeadsSection
            filterFunc={filterFunc}
            title={contactId ? "Other leads" : "Leads"}
          />
        </Layout.GridColumn>
      )}

      <Layout.GridColumn
        className={clsxMerge("pl-1 pr-2 pt-3", "flex flex-col gap-2")}
      >
        <NotepadSection inputClassName="max-h-none" />
      </Layout.GridColumn>
    </Layout.GridColumns>
  );
};
